import React from 'react';
import { LoginMetamask } from '../components/LoginMetamask'; // Adjust path
import { PageLayout } from '../components/PageElements';
import MetricsOverview from '../components/MetricsOverview';

export const DeeporbMetrics = ({config}) => {
  return (
    <>
      <div className='m-3'>
        <MetricsOverview config={config} />
      </div>
    </>
  );
};

